import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import "./Home.css";

export default function Home() {
    const { isAuthenticated } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const { business } = useAppContext();
    const history = useHistory();

    useEffect(() => {
        //ensures window scrolls to top when loading this page
        window.scrollTo(0, 0);

        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }

            //if user hasn't finished onboarding at least once before, route them back to sticker page
            if (!business.onboardingCompletionDate) {
                history.push("sticker");
            }

            setIsLoading(false);
        }
  
        onLoad();
    }, [isAuthenticated, business]);

    return (
        <div className="home">
            {isAuthenticated && !isLoading && (
                <div className="content">
                    <div className="contentBody">
                        <div className="menuContent">
                            <div className="menuContentImage">
                                <img alt="Order More Decals" src="https://sert-consumer.s3.amazonaws.com/images/decal-box.png"/>
                            </div>
                            <div className="menuContentText">
                                <h3><a href="/sticker">1. Order More Decals</a></h3>
                                Order more Sertify Stamps and/or custom photo decals.
                            </div>
                        </div>
                        <hr/>
                    </div>
                    { /*
                    <div className="contentBody">
                        <div className="menuContent">
                            <div className="menuContentImage">
                                <img alt="Edit You Story" src="https://sert-consumer.s3.amazonaws.com/images/laptop.jpg"/>
                            </div>
                            <div className="menuContentText">
                                <h3><a href="/story">2. Edit Your Story </a></h3>
                                Change your photo or story for our Sertify Directory   
                            </div>
                        </div>
                        <hr/>
                    </div>
                    */ }
                    <div className="contentBody">
                        <div className="menuContent">
                            <div className="menuContentImage">
                                <img alt="Download Sertify Stamps" src="https://sert-consumer.s3.amazonaws.com/images/stamps_3x3.png"/>
                            </div>
                            <div className="menuContentText">
                                <h3><a href="/stamps">2. Download Sertify Stamps</a></h3>
                                Get your Sertify Stamps for your digital media and website
                            </div>
                        </div>
                        <hr/>
                    </div>
                    <div className="contentBody">
                        <div className="menuContent">
                            <div className="menuContentImage">
                                <img alt="Customize Your Images" src="https://sert-consumer.s3.amazonaws.com/images/collage.jpg"/>
                            </div>
                            <div className="menuContentText">
                                <h3><a href="/socialcontent">3. Customize Your Images</a></h3>
                                Use our preset formats to create images for your digital media profiles
                            </div>
                        </div>
                        <hr/>
                    </div>
                    { /* 
                    <div className="contentHeader">
                        <h3>4. Browse Content</h3>
                    </div>
                    <div className="contentBody">
                        What else to Sertify? Download templates you want to show off your stamps
                    </div>
                    */}
                </div>
            )}
        </div>
    );
}